import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";
import Photoswipe from "./photoswipe.esm.min.js";

document.addEventListener('DOMContentLoaded', function() {
  if (window.navyProductMediaData && window.navyProductMediaData.length > 0) {
    // Rest of code remains the same
    window.onload = function() {
      function preloadImage(url) {
        const img = new Image();
        img.src = url;
      }

      function preloadSrcset(srcset) {
        const sources = srcset.split(', ');
        sources.forEach(source => {
          const src = source.split(' ')[0];
          preloadImage(src);
        });
      }

      window.navyProductMediaData.forEach(media => {
        preloadImage(media.src);
        if (media.srcset) {
          preloadSrcset(media.srcset);
        }
      });
    }

    // const zoomSvgString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-zoom"></use><path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"></path><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"></path><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"></path></svg>';
    // const closeSvgString = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-close"></use><path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"></path></svg>';
    // const zoomSvgString = '<svg aria-hidden="true" class="pswp__icn navy-test-class" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-zoom"></use><path stroke-width="1.5" d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"></path><path fill="currentColor" stroke-width="1.5" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"></path><path fill="currentColor" stroke-width="1.5" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"></path></svg>';
    
    // const closeSvgString = '<svg aria-hidden="true" class="pswp__icn navy-test-class" viewBox="0 0 32 32" width="32" height="32"><use class="pswp__icn-shadow" xlink:href="#pswp__icn-close"></use><path stroke-width="1.5" d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"></path></svg>';
    const zoomSvgString = '';
    
    const closeSvgString = '';
    
    const options = {
      dataSource: window.navyProductMediaData,
      showHideAnimationType: 'none', 
      pswpModule: () => Photoswipe,
      counter: false,
      maxZoomLevel: 3,
      zoomSvg: zoomSvgString,
      closeSvg: closeSvgString,
      mainClass: 'navy-pswp',
    };

    const lightbox = new PhotoSwipeLightbox(options);
    lightbox.init();

    const mediaToggles = document.querySelectorAll('.productView-image');
    mediaToggles.forEach(toggle => {
      toggle.addEventListener('click', function(event) {
          const mediaPosition = event.currentTarget.getAttribute('data-index');
          lightbox.loadAndOpen(mediaPosition - 1);
      });
    });
  }
});